import type maplibregl from "maplibre-gl";
import type { LayerStyleOutline } from "@designboticteam/map";
import { buildStateExpression } from "../expressionBuilders/buildStateExpression";

function createStyleOutlineLayer({
	sourceId,
	sourceLayerId,
	idleOutline,
	matchedOutline,
	hoverOutline,
	isVisible,
}: {
	sourceId: string;
	sourceLayerId: string;
	idleOutline: LayerStyleOutline;
	matchedOutline?: LayerStyleOutline;
	hoverOutline?: LayerStyleOutline;
	isVisible: boolean;
}): maplibregl.AddLayerObject {
	return {
		id: `${sourceId}__outline`,
		source: sourceId,
		"source-layer": sourceLayerId,
		type: "line",
		paint: {
			"line-color": buildStateExpression({
				literal: { idle: idleOutline.color, matched: matchedOutline?.color, hover: hoverOutline?.color ?? idleOutline.color },
			}),
			"line-opacity": buildStateExpression({
				globalStateModifierKey: `opacity__${sourceId}`,
				literal: { idle: idleOutline.opacity ?? 1, matched: matchedOutline?.opacity, hover: hoverOutline?.opacity ?? 1 },
			}),
			"line-width": buildStateExpression({
				literal: { idle: idleOutline.width ?? 1, matched: matchedOutline?.width, hover: hoverOutline?.width ?? idleOutline.width ?? 1 },
			}),
		},
		layout: { visibility: isVisible ? "visible" : "none" },
	};
}

export { createStyleOutlineLayer };
